import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import {ProcessResultI} from "../../../infrastructure/interfaces/process-result.interface";
import {
  selectLoadingBulkRemoveProcessResult,
  selectSelectedProcessResults
} from "../../../infrastructure/store/process-result/process-result.selector";
import {TranslateService} from "@mangosoft/mango-layout";
import {BsModalRef, BsModalService, ModalOptions} from "ngx-bootstrap/modal";
import {RemoveModalComponent} from "../modals/remove-modal/remove-modal.component";
import {
  bulkRemoveProcessResult,
  deleteProcessResult, setDetailProcessResult, setloadingBulkRemoveProcessResult,
  setLoadingResult, setSelectedProcessResults, setShowRightBar
} from "../../../infrastructure/store/process-result/process-result.actions";
import {ProcessI} from "../../../infrastructure/interfaces/process.interface";
import {selectSelectedProcess} from "../../../infrastructure/store/process/process.selector";

@Component({
  selector: 'app-general-bulk-actions',
  templateUrl: './general-bulk-actions.component.html',
  styleUrls: ['./general-bulk-actions.component.scss']
})
export class GeneralBulkActionsComponent implements OnInit, OnDestroy {
  destroy$: Subject<void> = new Subject();

  process: ProcessI | null = null;

  selectedProcessResults: ProcessResultI[] = [];
  language!: any;

  bsModalRef?: BsModalRef;

  loadingBulkRemoveProcessResult: boolean = false;

  deletePermissions: boolean = false;

  constructor(
    private store: Store,
    private translateService: TranslateService,
    private modalService: BsModalService,
  ) {
    this.translateService
      .init("process-manager")
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.language = data
      });
  }

  ngOnInit() {
    this.store.select(selectSelectedProcess).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.process = value;
    });

    this.store.select(selectSelectedProcessResults).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.selectedProcessResults = value;

      this.deletePermissions = this.selectedProcessResults.reduce((current, result) => {
        return current && result.user_permissions.delete;
      }, true)

    });

    this.store.select(selectLoadingBulkRemoveProcessResult).pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.loadingBulkRemoveProcessResult = value;
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  remove(event: any, items: ProcessResultI[]) {
    event.stopPropagation();

    const initialState: ModalOptions = {
      initialState: {
        language: this.language,
        message: this.language.bulkDeleteMessage.replace('{{total}}', this.selectedProcessResults.length),
        item: items
      },
      backdrop: "static",
      keyboard: false,
      class: "modal-sm"
    };
    this.bsModalRef = this.modalService.show(RemoveModalComponent, initialState);
    this.bsModalRef.content.action.pipe(
      takeUntil(this.destroy$)
    ).subscribe((value: ProcessResultI[]) => {
      if (this.process){
        console.log("Removing process results =>", value.map(v=>v.id))
        this.store.dispatch(setloadingBulkRemoveProcessResult({status: true}));
        this.store.dispatch(bulkRemoveProcessResult({
          processId: this.process.id,
          values: this.selectedProcessResults.map(p=>p.id)
        }));
      }
    })
  }

  unselectAll() {
    this.store.dispatch(setSelectedProcessResults({value: []}));
    this.store.dispatch(setShowRightBar({status: false}));
    this.store.dispatch(setDetailProcessResult({result: null}));
  }

}
